import React from 'react';
import { HashRouter } from 'react-router-dom';
import { Auth0Provider } from '@auth0/auth0-react';
import { AuthProvider } from './services/AuthContext';
import customTheme from './themeConfig';
import { ThemeProvider } from '@mui/material/styles';
import Router from './routes';
import './App.scss';

const App: React.FC = () => {
  return (
    <Auth0Provider
      domain="your-auth0-domain.auth0.com"
      clientId="your-auth0-client-id"
      authorizationParams={{
        redirect_uri: window.location.origin,
      }}
    >
      <AuthProvider>
        <ThemeProvider theme={customTheme}>
          <HashRouter>
            <Router />
          </HashRouter>
        </ThemeProvider>
      </AuthProvider>
    </Auth0Provider>
  );
};

export default App;
